module.exports = {
      id: "edit-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#edit",
      toString: function () {
        return this.url;
      }
    }